import { render, staticRenderFns } from "./create-user-assignment.vue?vue&type=template&id=35c98f3a"
import script from "./create-user-assignment.vue?vue&type=script&lang=ts"
export * from "./create-user-assignment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports